import { lddStateObject, setPreference } from "./reducer"

export const PreferenceDispatch = <T extends keyof lddStateObject["Preference"]>(
    key: keyof lddStateObject["Preference"],
    option: lddStateObject["Preference"][T]
) => (dispatch) => {
    dispatch(setPreference(key, option))
}